module.exports = __webpack_public_path__ + "static/media/comments-dollar.1c4c6055.svg";